module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_rogaland_neg.fae9366e.pdf";